import { defineComponent, PropType } from "@vue/composition-api";
import { formatStringDateOnly } from "@/functions/format-functions";
import { CreditTransactionItem } from "@/functions/credit-functions";
import { i18n } from "@/utilities/vue-i18n";
import { PromotionType } from "@/states/promotion-state";

export default defineComponent({
    props: {
        transactions: {
            type: Array as PropType<CreditTransactionItem[]>,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const getTransactionAmount = (transaction: CreditTransactionItem) => {
            const amountsStrings = transaction.amount.map(amount => `${amount.amount} ${i18n.t(`general.promotion.title.${amount.type}`)}`);

            return amountsStrings.join(', ');
        };

		function getTransactionDescription(transaction: CreditTransactionItem): string {
			if (transaction.description === 'TRANSACTION_MONTHLY_CREDITS') {
				const promotionType = transaction.amount[0]?.type as PromotionType;
				return i18n.t('company-credit-transactions.monthly-credits-updated', { promotionType: i18n.t(`general.promotion.title.${promotionType}`) }) as string;
			}
			if (transaction.type === 'buy') {
				return i18n.t('company-credit-transactions.table-header.bought-credits') as string;
			}
			return transaction.title;
		}
		
        return {
            formatStringDateOnly,
            getTransactionAmount,
            getTransactionDescription,
        }
    },
})